<template>
  <v-container>
    <v-row>
      <v-col
          md="12"><h4>Add a team</h4>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col md-4>
        <v-text-field
            label="Team name"
            :rules="rules"
            v-model="teamName"
            hide-details="auto"
        ></v-text-field>
      </v-col>
      <v-col>
      <v-text-field
          label="Class name"
          :rules="rules"
          v-model="className"
          hide-details="auto"
      ></v-text-field>
      </v-col>
      <v-col>
        <v-checkbox
            v-model="greenFleet"
            :label="`Green Fleet`"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-row v-for="index in $store.state.event.boatsPerTeam" :key="index">
      <v-col md-4>
        <v-text-field
            :label='"Skipper " +index'
            :rules="rules"
            v-model="teamSkippers[index-1]"
            hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <v-btn
            color="primary"
            elevation="2"
            v-on:click="addTeam()"
        >Add Team
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>{{ errorMessage }}</v-col>
    </v-row>
  </v-container>
</template>

<script>
//import {rounds} from "@/utils/rounds"
//import {teams} from "@/utils/teams";
import {db} from "@/db";

export default {

  data: () => ({
    teamName: null,
    teamSkippers: [],
    errorMessage: "",
    greenFleet: false,
    className: "Optimist",

    rules: [
      value => !!value || 'Required.',
      value => (value && value.length >= 3) || 'Min 3 characters',
    ],
  }),
  methods: {
    addTeam: function () {
      const vm=this;
      this.errorMessage = "";
      let exists = false;
      db.collection(`events/${this.$store.state.event.id}/teams`)
          .get()
          .then(querySnapshot => {
            querySnapshot.forEach((snapshot) => {
              if (snapshot.data().name === vm.teamName) {
                this.errorMessage = "Error: A team with this name already exists!"
                exists=true;
              }
            })
            if(!exists){
              this.saveTeam(querySnapshot.size + 1);
            }
          })
    },
    saveTeam: function (teamId) {
      teamId+="";// make it a string
      const newTeam = {};
      newTeam.teamId = teamId;
      newTeam.name = this.teamName;
      newTeam.skippers = this.teamSkippers;
      newTeam.greenFleet = this.greenFleet;
      newTeam.className = this.className;

      return db.collection(`events/${this.$store.state.event.id}/teams`)
          .doc(teamId+"")
          .set(newTeam)
          .then(() => {
            this.errorMessage = ('Team ' + newTeam.teamId + ' added!');
          })
    },

  },

  computed: {}
}
</script>

<style>


</style>